import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ai-git-branch"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6 16C7.38071 16 8.5 17.1193 8.5 18.5C8.5 19.8807 7.38071 21 6 21C4.61929 21 3.5 19.8807 3.5 18.5C3.5 17.1193 4.61929 16 6 16Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M18 3C19.3807 3 20.5 4.11929 20.5 5.5C20.5 6.88071 19.3807 8 18 8C16.6193 8 15.5 6.88071 15.5 5.5C15.5 4.11929 16.6193 3 18 3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.5 18.5C8.5 17.1193 7.38071 16 6 16C4.61929 16 3.5 17.1193 3.5 18.5C3.5 19.8807 4.61929 21 6 21C7.38071 21 8.5 19.8807 8.5 18.5ZM8.5 18.5C10.1569 18.5 11.5 17.1569 11.5 15.5V8.5C11.5 6.84314 12.8431 5.5 14.5 5.5L15.5 5.5M15.5 5.5C15.5 6.88071 16.6193 8 18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3C16.6193 3 15.5 4.11929 15.5 5.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M5 4L5.33234 4.66766L6 5L5.33234 5.33234L5 6L4.66766 5.33234L4 5L4.66766 4.66766L5 4Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M18.5 16.25L19.2 17.8L20.75 18.5L19.2 19.2L18.5 20.75L17.8 19.2L16.25 18.5L17.8 17.8L18.5 16.25Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const AiGitBranch = Vue.extend<IconProps>({
  name: 'AiGitBranchIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-git-branch',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiGitBranch;
